import { ElMessageBox } from 'element-plus'
import { logoutApi } from '@/api/user.api'
import store from '@/store'
import router from '@/router'
import { getToken, removeToken, getCargoOwnerInfo } from '@/utils/auth'
import { useMessageCenter } from '@/message/useMessageCenter'

/**
 * @description 退出登录
 */
export async function logout() {
    if (getToken()) {
        logoutApi()
        removeToken()
        store.commit('upOrgList', [])
    }
    router.push('/login')
}

export function checkAndAlertError(data) {
    const NO_LOGIN = 105
    const ERROR_STATUS = 1
    if (data && +data.code !== 0) {
        if (data && +data.code === NO_LOGIN) {
            alertErrorAndLogout(data.msg || '当前没有登录的用户')
        } else if (data && +data.code === ERROR_STATUS) {
            alertErrorAndLogout('当前票据已失效，请重新登录')
        } else {
            alertErrorAndLogout(data.msg || '接口返回异常')
        }
    }
}

export function alertErrorAndLogout(msg) {
    ElMessageBox.alert(msg, '错误', {
        confirmButtonText: '确定',
        callback: () => {
            logout()
        },
    })
}

/**
 * @description 获取当前页面的ticket
 */
export function getUrlTicket() {
    const reg = new RegExp('(^|&)' + 'ticket' + '=([^&]*)(&|$)', 'i')
    const result = window.location.search.substr(1).match(reg) || []
    if (result[2]) {
        return decodeURI(result[2])
    } else {
        return null
    }
}

/**
 * @description 判断当前cookies是否有某字符串的键
 */
export function hasCookies(params) {
    const allCookies = document.cookie.split(';')
    allCookies.map(item => {
        const cookieKeys = item.split('=')
        return cookieKeys && cookieKeys[0]
    })
    const res = allCookies.findIndex(value => {
        const result1 = value.indexOf(params)
        return result1 !== -1
    })
    return res !== -1
}

/**
 * data 接收的数据
 * @description 判断当前登录货主
 */
export function formatLoginInfo(data, switchOwnerData) {
    console.log('store.getters.identityInfo', store.getters.identityInfo)
    const found = data.find(x => store.getters.identityInfo.anhzCode === x.anhzCode)
    if (found) return found

    for (const key in data) {
        if (data[key].flag === 0) {
            // 0为当前货主
            return data[key]
        }
    }
}

/**
 * @description vue实例前判断登录状态，初始登录信息
 */
export async function checkLogin() {
    const path = window.location.href.split('#')[1]
    const wihtePath = ['/login', '/nfp-register', '/main-page', '/mp-user-bind']
    if (wihtePath.includes(path)) {
        return true
    } else if (!getToken()) {
        logout()
        return false
    } else {
        store.commit('updateUserIdentity', formatLoginInfo(JSON.parse(getCargoOwnerInfo())))
        store.dispatch('initTenantsData')
        const mc = useMessageCenter()
        mc.post(mc.create('info', '/auth/logined', ''))
        return true
    }
}
